import { ReactElement } from 'react';
import infoSvg from 'assets/icons/info.svg';
import warning from 'assets/icons/warning.svg';
import SvgIcon from 'lib/SvgIcon/SvgIcon';
import { Color } from 'lib/SvgIcon/SvgIcon.types';
import { DealLinesIconProps, DealLinesStatus } from './DealLinesIcon.types';

const dealLineStatusIcon: Record<DealLinesStatus, { src: string; color: Color }> = {
  [DealLinesStatus.BOOKING_STATUS_FAILED]: {
    src: infoSvg,
    color: Color.DANGER,
  },
  [DealLinesStatus.LINE_WITH_OUT_OF_CHARGE_FRAMES]: {
    src: warning,
    color: Color.WARNING,
  },
};

const DealLinesIcon: React.FC<DealLinesIconProps> = ({ status }): ReactElement => {
  return (
    <div className="p-2 flex">
      <SvgIcon src={dealLineStatusIcon[status].src} color={dealLineStatusIcon[status].color} className="w-full" />
    </div>
  );
};

export default DealLinesIcon;
